<rid-lettermix
  class="h-dvh"
  [wordMatrix]="[
    [
      ['aa', 'p'],
      ['p', 'aa', 'l'],
      ['aa', 'l'],
    ],
    [
      ['m', 'aa', 'n'],
      ['n', 'aa', 'm'],
      ['aa', 'n'],
    ],
  ]"
  (finished)="$router.navigate(['/mechanics/phonetic-comprehension'])"
/>
